'use strict';

var PARAM_NAME_PATTERN = /^[a-zA-Z_][a-zA-Z0-9_-]*$/;

var options5Ctrl = ['$translate', 'dialog', '$timeout', function ($translate, dialog, $timeout) {
    var _this = this;
    _this.editMode = [];

    function normalizeValue(rawValue) {
        if (rawValue == null) return null;
        var value = String(rawValue).trim().replace(/"/g, '');
        if (!value || /\s/.test(value) || !PARAM_NAME_PATTERN.test(value)) {
            return null;
        }
        return value;
    }

    function parseParamsFromClipboard(clipboardText) {
        var parsed = clipboardText.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
        if (!parsed || parsed.length === 0) {
            return { validOptions: [], invalidValues: [] };
        }

        var used = {};
        var validOptions = [];
        var invalidValues = [];

        parsed.forEach(function (rawValue) {
            var value = normalizeValue(rawValue);
            if (!value) {
                var trimmed = String(rawValue).trim().replace(/"/g, '');
                if (trimmed) invalidValues.push(trimmed);
                return;
            }
            if (used[value]) return;
            used[value] = true;
            validOptions.push(value);
        });

        return { validOptions: validOptions, invalidValues: invalidValues };
    }

    _this.addOption = function (newValue) {
        if (!newValue) return;

        _this.options = _this.options || [];
        var parsedValues = newValue.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g) || [];
        var invalidValues = [];
        var valuesToAdd = [];

        parsedValues.forEach(function (rawValue) {
            var value = normalizeValue(rawValue);
            if (!value) {
                var trimmed = String(rawValue).trim().replace(/"/g, '');
                if (trimmed) invalidValues.push(trimmed);
                return;
            }
            if (_this.options.indexOf(value) === -1 && valuesToAdd.indexOf(value) === -1) {
                valuesToAdd.push(value);
            }
        });

        if (invalidValues.length > 0) {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_INVALID_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_INVALID_BODY') + ' ' + invalidValues.join(', ')
            );
        }

        valuesToAdd.forEach(function (value) {
            _this.options.push(value);
        });

        _this.newOption = null;
    };

    _this.finishEdit = function (index) {
        var value = normalizeValue(_this.options[index]);
        if (!value) {
            _this.options.splice(index, 1);
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_INVALID_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_INVALID_EDIT_BODY')
            );
        } else if (_this.options.some(function (item, i) { return i !== index && item === value; })) {
            _this.options.splice(index, 1);
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_DUPLICATE_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_DUPLICATE_BODY')
            );
        } else {
            _this.options[index] = value;
        }
        _this.editMode[index] = false;
    };

    _this.edit = function (index) {
        _this.editMode[index] = true;
        $timeout(function () {
            var ele = document.getElementById('chip_item_' + index);
            if (ele) ele.focus();
        }, 100);
    };

    _this.copyOptions = function () {
        var copyElement = document.createElement('textarea');
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        var str = (_this.options || []).reduce(function (acc, val) {
            return acc + '"' + String(val).replace(/"/g, '') + '",';
        }, '');
        str = str.substring(0, str.length - 1);
        copyElement.textContent = str;
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
    };

    _this.pasteOptions = function () {
        if (!navigator.clipboard || !navigator.clipboard.readText) {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_CLIPBOARD_UNAVAILABLE_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_CLIPBOARD_UNAVAILABLE_BODY')
            );
            return;
        }

        navigator.clipboard.readText().then(function (clipboardText) {
            var result = parseParamsFromClipboard(clipboardText);
            var validOptions = result.validOptions;
            var invalidValues = result.invalidValues;

            if (invalidValues.length > 0) {
                _this.errorMessage(
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_INVALID_TITLE'),
                    $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS5_DIR.ERR_INVALID_BODY') + ' ' + invalidValues.join(', ')
                );
            }

            if (validOptions.length === 0) {
                if (invalidValues.length === 0) {
                    _this.errorMessage(
                        $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_INVALID_TITLE'),
                        $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_INVALID_BODY')
                    );
                }
                return;
            }

            $timeout(function () {
                _this.options = validOptions;
            });
        }).catch(function () {
            _this.errorMessage(
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_READ_FAILED_TITLE'),
                $translate.instant('DASHBOARD.DASH_BUILDER.OPTIONS_DIR.ERR_PASTE_READ_FAILED_BODY')
            );
        });
    };

    _this.removeChip = function (index) {
        _this.options.splice(index, 1);
    };

    _this.removeAll = function () {
        _this.options = [];
    };

    _this.errorMessage = function (title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant('DASHBOARD.CLOSE'),
            size: 'md'
        });
    };
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            hidehelp: '=',
            legend: '@',
            help: '@'
        },
        replace: true,
        controller: options5Ctrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/options5Directive.html'
    };
};
